import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';
import { API_BASE_URL } from '../constants/api';

export const supportApi = createApi({
  reducerPath: 'supportApi',
  baseQuery: createAuthBaseQuery(API_BASE_URL),
  tagTypes: ['Ticket'],
  endpoints: (builder) => ({
    createTicket: builder.mutation({
      // Sends JSON normally, and multipart only when files are attached.
      //
      // Both shapes matter: the mobile app and anything else already
      // posting a plain object must keep working, and the backend's multer
      // passes a non-multipart request straight through. The body is NOT
      // hand-serialised and no Content-Type is set — fetchBaseQuery detects
      // a FormData body and lets the browser write the multipart boundary,
      // which is the one header you cannot set correctly yourself.
      query: ({ attachments, ...fields } = {}) => {
        if (!attachments || attachments.length === 0) {
          return { url: '/support/tickets', method: 'POST', body: fields };
        }
        const fd = new FormData();
        for (const [k, v] of Object.entries(fields)) {
          if (v !== undefined && v !== null) fd.append(k, String(v));
        }
        for (const file of attachments) fd.append('attachments', file, file.name);
        return { url: '/support/tickets', method: 'POST', body: fd };
      },
      invalidatesTags: ['Ticket'],
    }),
    listMyTickets: builder.query({
      query: () => '/support/tickets',
      providesTags: ['Ticket'],
    }),
    getMyTicket: builder.query({
      query: (id) => `/support/tickets/${encodeURIComponent(id)}`,
      providesTags: (_r, _e, id) => [{ type: 'Ticket', id }],
    }),
    replyToTicket: builder.mutation({
      query: ({ id, message }) => ({
        url: `/support/tickets/${encodeURIComponent(id)}/reply`,
        method: 'POST',
        body: { message },
      }),
      invalidatesTags: (_r, _e, { id }) => ['Ticket', { type: 'Ticket', id }],
    }),
  }),
});

export const {
  useCreateTicketMutation,
  useListMyTicketsQuery,
  useGetMyTicketQuery,
  useReplyToTicketMutation,
} = supportApi;
